export enum UnsavedChangesState {
  Block = 'block',
  Blocked = 'blocked',
  LeavePage = 'leavePage',
  CloseModal = 'closeModal'
}
